import React from 'react';

function AnythingDetailsPosition({ anything, ...rest }) {
  const { value1: latitude, value2: longitude } = anything;
  return (
    <div {...rest}>
      <h5>
        Lat: {latitude}
        <br />
        Long: {longitude}
      </h5>
      <a
        target="_blank"
        rel="noreferrer"
        href={`https://maps.google.com/maps?q=${latitude},${longitude}`}
      >
        Google Maps
      </a>
    </div>
  );
}

export default AnythingDetailsPosition;
